import * as v from "valibot";

import { rpcContract } from "../rpc";

export const linksQueryRpcContract = rpcContract({
  name: "linksQuery",
  paramsSchema: v.undefined(),
  resultSchema: v.object({
    links: v.array(
      v.object({
        id: v.string(),
        title: v.string(),
        url: v.string(),
        imageUrl: v.nullable(v.string()),
      }),
    ),
  }),
});

export type LinksQueryParams = v.InferOutput<(typeof linksQueryRpcContract)["paramsSchema"]>;
export type LinksQueryResult = v.InferOutput<(typeof linksQueryRpcContract)["resultSchema"]>;
export type Link = v.InferOutput<(typeof linksQueryRpcContract)["resultSchema"]>["links"][number];
